export default {"src":"/_next/static/media/shield-lock-2.ddddd348.svg","height":37,"width":37,"blurWidth":0,"blurHeight":0};